/**
 * One tool call observed during a custom-agent builder run, surfaced on the
 * builder's response payload and rendered by the browser's config-agent view.
 */
export interface CustomAgentBuilderToolCall {
  id: string
  name: string
  input: unknown
  output: unknown
}

/** Result actions address stable items, falling back for rows predating item IDs. */
export function customAgentResultItemId(item: { id: string; item_id?: string | null }): string {
  return item.item_id || item.id
}
